<div class="account-user">
  <eid-avatar [first]="account.user.name"></eid-avatar>
  <span class="name">{{ account.user.name }}</span>
</div>
<div class="eid-account-type eid-account-type--{{ account.type.name }}">
  <span>{{ account.type.label }}</span>
</div>
